
import { queryClient  } from '../../state/queryClient';
import { axios_cabinetscompagnies_updateauth } from '../../axios/axios_cabinetscompagnies';
 

export function deleteNoAuthTarif(usernotarif,comp,gam,tarif){
    delete usernotarif?.[comp]?.[gam]?.[tarif] ;
    if(Object.keys(usernotarif?.[comp]?.[gam])?.length===0){delete usernotarif?.[comp][gam] }
    if(Object.keys(usernotarif?.[comp])?.length===0){delete usernotarif?.[comp]}
    return usernotarif 
}


function getOrCreate(obj,key,defaultValue){
    if(!obj.hasOwnProperty(key)){ obj[key]=  defaultValue }
    return obj[key]
}

export function createNoAuthTarif(usernotarif={},comp,gam,tarif){
    getOrCreate(getOrCreate(getOrCreate(usernotarif,[comp],{}),[gam],{}),[tarif],true) ;
    return usernotarif 
}



// DEV AUTH

export async function changeGrouperoleAuthMemo({courtier,actuauths,compagnie_mini,gamme_mini,type_tarif,ROLE,newvalue}){
    let copyauths= JSON.parse(JSON.stringify(actuauths))  ;
    if(!copyauths[compagnie_mini]){copyauths[compagnie_mini]={} ;copyauths[compagnie_mini]['gammes']={}}
    if(!copyauths[compagnie_mini]['gammes'][gamme_mini]){copyauths[compagnie_mini]['gammes'][gamme_mini]={'tarifs':{[type_tarif]:{'autorisations':{[ROLE]:0}}}}}
    copyauths[compagnie_mini]['gammes'][gamme_mini]['tarifs'][type_tarif]['autorisations'][ROLE] = newvalue;
    await axios_cabinetscompagnies_updateauth({'courtier':courtier , 'autorisation':copyauths , ROLE , 'type': newvalue!==1?'deleteAuth':'addAuth' ,compagnie_mini,gamme_mini,type_tarif })
    return copyauths
}

export async function changeGrouperoleAuth({courtier, actuauths, compagnie_mini, gamme_mini, type_tarif, ROLE, newvalue}) {
    // 1. Initialisation de base si actuauths est null/undefined
    let copyauths = actuauths ? JSON.parse(JSON.stringify(actuauths)) : {};

    // 2. Sécurisation de chaque niveau (on vérifie l'existence de la clé parente ET de la clé cible)
    if (!copyauths[compagnie_mini]) copyauths[compagnie_mini] = { gammes: {} };
    
    if (!copyauths[compagnie_mini].gammes[gamme_mini]) {
        copyauths[compagnie_mini].gammes[gamme_mini] = { tarifs: {} };
    }

    if (!copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif]) {
        copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif] = { autorisations: {} };
    }

    // AJOUT SÉCURITÉ : Si le tarif existe mais n'a pas encore de clé 'autorisations'
    if (!copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif].autorisations) {
        copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif].autorisations = {};
    }

    // 3. Assignation (ne peut plus planter car .autorisations existe forcément)
    copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif].autorisations[ROLE] = newvalue;

    await axios_cabinetscompagnies_updateauth({
        courtier,
        autorisation: copyauths,
        ROLE,
        type: newvalue !== 1 ? 'deleteAuth' : 'addAuth',
        compagnie_mini,
        gamme_mini,
        type_tarif
    });

    return copyauths;
}


export async function changeGrouperoleAuthCHATGPT({courtier,actuauths,compagnie_mini,gamme_mini,type_tarif,ROLE,newvalue}) {
    const copyauths = { ...actuauths }; // Clonage simple pour éviter JSON.parse/JSON.stringify
    copyauths[compagnie_mini] ??= { gammes: {} };
    copyauths[compagnie_mini].gammes[gamme_mini] ??= { tarifs: {} };
    copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif] ??= { autorisations: {} };
    copyauths[compagnie_mini].gammes[gamme_mini].tarifs[type_tarif].autorisations[ROLE] = newvalue;
  
    const type = newvalue !== 1 ? "deleteAuth" : "addAuth"
    await axios_cabinetscompagnies_updateauth({courtier,autorisation: copyauths,ROLE,compagnie_mini,gamme_mini,type_tarif,type});
  
    return copyauths;
  }